import Modal from 'react-bootstrap/Modal'
import { useNavigate, useParams } from 'react-router-dom'
interface IModalProps {
    show: boolean
    onHide: () => void
    title?: string
}
export default function BuyPlanModal({ show, onHide, title }: IModalProps) {
    const navigate = useNavigate()
    const { id } = useParams()
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className=" w-full text-center py-4 text-xs">
                {title ? (
                    <p>{title}</p>
                ) : (
                    <p>
                        برای فعال کردن این گزینه بایذ صندوق خود را ارتقاء دهید
                    </p>
                )}
                <hr className=" my-2" />
                <button
                    className=" text-xs text-current"
                    form="authProfile"
                    onClick={() => navigate(`/fund/plans/${id}`)}
                >
                    ارتقاء صندوق
                </button>
                <hr className=" my-2" />
                <p className=" text-xs cursor-pointer" onClick={onHide}>
                    انصراف
                </p>
            </div>
        </Modal>
    )
}
